import { WSFilter } from "@wingspanhq/fe-component-library";
import { ListInternalAccountTransactionsFilterParameterStatusEq } from "@wingspanhq/wingspan-api-sdk";

export const TRANSACTION_STATUS_FILTER_ALL = "All";

export function buildInternalAccountTransactionsFiltersConfig(): WSFilter[] {
  return [
    {
      title: "Status",
      name: "status",
      type: "radio",
      options: [
        { name: TRANSACTION_STATUS_FILTER_ALL, label: "All", hidePill: true },
        {
          name: ListInternalAccountTransactionsFilterParameterStatusEq.ACTIVE,
          label: "Active"
        },
        {
          name: ListInternalAccountTransactionsFilterParameterStatusEq.PENDING,
          label: "Pending"
        },
        {
          name: ListInternalAccountTransactionsFilterParameterStatusEq.INACTIVE,
          label: "Inactive"
        }
      ]
    }
  ];
}
